export const SET_FILTER_TURNSTILE = 'SET_FILTER_TURNSTILE'
export const RESET_FILTER_TURNSTILE = 'RESET_FILTER_TURNSTILE'

const defaultState = {
    search: '',
    connected: null,    // null=vše, true=připojen, false=odpojen
    entryType: null,    // null=vše, 0=Východ, 1=Vchod, 2=V areálu
    turnstileType: null, // null=vše, číslo typu výrobce
    zoneIds: [],         // prázdné=vše, pole id zón
    onlyAlerts: false,  // true=jen zařízení s alertem
    autoRefresh: false  // true=automatický refresh každých 30s
}

export default function filterTurnstile(state = defaultState, action) {
    switch (action.type) {
        case SET_FILTER_TURNSTILE:
            return {...state, ...action.payload}
        case RESET_FILTER_TURNSTILE:
            return defaultState
        default:
            return state
    }
}
